<div #top>
  <p [innerHTML]="(!cameraError? 'heizcheck.foto.teaser' : cameraError) | translate | safeHtml" (click)="testCameraCapabilities()"></p>
  @if (!cameraError) {
    <p [innerHTML]="'heizcheck.foto.error.desktop' | translate"></p>
  }
</div>

@if (!cameraError) {
  <div class="photo-wrapper">
    @if (takePhoto) {
      <app-document-camera textprefix="heizcheck." (closeCamera)="cameraStopped($event)"></app-document-camera>
    }
    <app-msp [(model)]="msp"></app-msp>
    <div class="grid-x grid-margin-x">
      @for (item of photos; track item; let i = $index) {
        <div class="cell small-12 medium-6 large-4">
          <div class="file-wrapper has-photo">
            <button type="button" class="button" [class.loading]="i === currentPhoto"><i class="icon-camera"></i></button>
            <img alt="" class="preview" id="preview-{{i}}" [src]="item.url">
            <button class="show-preview"><i class="icon-eye"></i></button>
            <span>{{'heizcheck.foto.page' | translate: {page: (i + 1)} }}</span>
          </div>
        </div>
      }
      <div class="cell small-12 medium-6 large-4">
        <div class="file-wrapper" (click)="startCamera($event, photos.length)">
          <button type="button" class="button" [class.loading]="photos.length === currentPhoto"><i class="icon-camera"></i>@if (photos.length + 1 !== currentPhoto) {
          {{'heizcheck.foto.makephoto' | translate: {page: (photos.length + 1)} }}
        }</button>
      </div>
    </div>
  </div>
  <app-terms [textPrefix]="'heizcheck.'" (onUpdate)="terms = $event"></app-terms>
  @if (error) {
    <div role="alert" class="form-errors" [innerHTML]="('heizcheck.foto.error' + error) | translate"></div>
  }
  <app-upload-button [label]="getButtonText()" [uploadPercentage]="uploadPercentage" [class]="'button primary'" [disabled]="fileUploadPossible() !== 0" (click)="uploadData()"></app-upload-button>
  <p class="data-protection" [innerHTML]="'heizcheck.upload.submit.dataprotection' | translate"></p>
  <div class="imagecheck" [class.hide]="imageCheck == null" #imagecheck>
    <div class="top-buttons">
      <button type="button" [attr.aria-label]="'arialabel.delete.foto' | translate" (click)="deletePhoto(imageCheck)"><i class="icon-trash"></i></button>
    </div>
    <img alt="" id="imagecheck-image" [src]="photos[imageCheck]? photos[imageCheck].url : null">
    <div class="bottom-buttons">
      <button class="button" (click)="closeImageCheck()">{{'heizcheck.foto.imagecheck.ok' | translate}}<i class="icon-check"></i></button>
      <button class="button hollow" (click)="startCamera($event, imageCheck)">{{'heizcheck.foto.imagecheck.retry' | translate}}</button>
    </div>
  </div>
</div>
}


@if (fromDesktop === false) {
  <app-step-buttons previousLink="../heizkostenabrechnung/start" leftAlignSize="small" previousText="step.button.previous" [nextLink]="null" [nextSubmit]="false"></app-step-buttons>
}
